import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type ErrorFallbackProps = {
    resetError: () => void;
};

export function ErrorFallback({ resetError }: ErrorFallbackProps): ReactElement {
    const { t } = useTranslation();
    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <Typography variant="h5" gutterBottom>
                {t('ERRORS.GENERIC.TITLE')}
            </Typography>
            <Typography color="text.secondary" gutterBottom>
                {t('ERRORS.GENERIC.DESCRIPTION')}
            </Typography>
            <Button variant="outlined" onClick={resetError} sx={{ mt: 1 }}>
                {t('ACTIONS.TRY_AGAIN')}
            </Button>
        </div>
    );
}
